import React from 'react'

interface IProps {
  name?: string
}

const About: React.FC<IProps> = (props) => {
  return <>this is about {props.name}</>
}

export default About
